import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { useAuth } from "../../contexts/AuthContext";
import { UserDropdown } from "./UserDropDown";

export const DesktopNav = () => {
  const { isAuthenticated, logout } = useAuth();

  return (
    <nav className="hidden md:flex items-center space-x-8">
      <Link
        to="/browse"
        className="text-foreground/90 hover:text-foreground transition-colors"
      >
        Browse
      </Link>
      <Link
        to="/"
        state={{ scrollTo: "how-it-works" }}
        className="text-foreground/90 hover:text-foreground transition-colors"
      >
        How It Works
      </Link>
      <Link
        to="/resources"
        className="text-foreground/90 hover:text-foreground transition-colors"
      >
        Resources
      </Link>
      {isAuthenticated ? (
        <>
          {/* <Link to="/create-listing" className="text-foreground/90 hover:text-foreground transition-colors">
            Create Listing
          </Link> */}
          <UserDropdown onLogout={logout} />
        </>
      ) : (
        <>
          <Link to="/auth?mode=login">
            <Button
              variant="outline"
              className="border-igbanwo-mint/20 hover:border-igbanwo-mint/40"
            >
              Sign In
            </Button>
          </Link>
          <Link to="/auth?mode=register">
            <Button className="bg-igbanwo-mint hover:bg-igbanwo-mint/90 text-white">
              Join Now
            </Button>
          </Link>
        </>
      )}
    </nav>
  );
};